import api from './api';

const dashboardService = {
  // Get dashboard stats (counts of entities)
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  // Get transaction chart data for last 10 days
  getChartData: async () => {
    const response = await api.get('/dashboard/chart');
    return response.data;
  }
};

export default dashboardService;
